import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import type { IBarChartTooltipProps } from '../types';

/**
 * 柱状图 Tooltip 组件
 */
const BarChartTooltip: React.FC<IBarChartTooltipProps> = (props) => {
  const { showDataSourceIcon = false, title, metricName, timeRange, dataList } = props;
  const headerText = timeRange || title;

  return (
    <div className="v3-chart-tooltip v3-bar-tooltip">
      <div className="v3-tooltip-table">
        {(headerText || metricName || (showDataSourceIcon && dataList[0]?.dataSourceIcon)) && (
          <>
            <div className="v3-tooltip-cell v3-tooltip-cell--left">
              {headerText && <div className="v3-tooltip-header-text">{headerText}</div>}
            </div>
            <div className="v3-tooltip-cell v3-tooltip-cell--right">
              <div className="v3-tooltip-title-right">
                {showDataSourceIcon && dataList[0]?.dataSourceIcon && (
                  <img
                    className="v3-tooltip-datasource-icon"
                    src={dataList[0].dataSourceIcon}
                    alt="dataSource"
                    width={14}
                    height={14}
                  />
                )}
                {metricName && <div className="v3-tooltip-title-text">{metricName}</div>}
              </div>
            </div>
          </>
        )}
        {dataList.map((item, index) => (
          <React.Fragment key={index}>
            <div className="v3-tooltip-cell v3-tooltip-cell--left">
              <div className="v3-tooltip-list-item-left">
                <span className="v3-tooltip-list-item-dot" style={{ backgroundColor: item.color }} />
                {item.iconUrl && (
                  <img className="v3-tooltip-list-item-icon" src={item.iconUrl} alt={item.iconAlt || item.name} />
                )}
                <span className="v3-tooltip-list-item-name">{item.name}</span>
              </div>
            </div>
            <div className="v3-tooltip-cell v3-tooltip-cell--right">
              <div className="v3-tooltip-list-item-right">
                <span className="v3-tooltip-list-item-value">{item.value}</span>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

/**
 * 渲染柱状图 Tooltip 为 HTML 字符串
 */
export const renderBarChartTooltip = (props: IBarChartTooltipProps): string => {
  return renderToStaticMarkup(<BarChartTooltip {...props} />);
};

export default BarChartTooltip;
